/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { FileService } from '@store/service/FileService';
import ErrorResponseMixin from '@mixin/errorResponse';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            file: {
                disabled: true,
                name: null,
                href: null,
                downloading: false,
            },
            files: [],
        };
    },

    created() {
        this.fileService = new FileService(this.$store);
    },

    mixins: [
        ErrorResponseMixin,
    ],

    computed: {
        visibleFiles() {
            return this.post.files.filter((file, index) => {
                return index === 0 || this.post.files[index].file || this.post.files[index - 1].file || this.files[index].name || this.files[index - 1].name;
            });
        }
    },

    methods: {
        async getFiles(post: object, files: null) {
            const resultFiles = [];
            files = (files) ? files : this.files;

            files.forEach(file => {
                file.downloading = true;
            });

            return await this.fileService.getFile(post.id, post.owner, post.type).then(response => {
                files.forEach(file => {
                    file.disabled = false;
                });

                if (response instanceof Error || !response.data[0]) {
                    files.forEach(file => {
                        file.downloading = false;
                    });
                    return true;
                }

                response.data.forEach((responseFile, i) => {
                    const fileName = (responseFile.filename) ? responseFile.filename : responseFile.type;
                    files[i].name = `${ fileName }.${ responseFile.extension }`;
                    files[i].id = responseFile.id;
                    resultFiles.push(files[i]);
                });

                return resultFiles;
            });
        },

        async downloadFile(post: object, file = null) {
            file = (file) ? file : this.file;

            return await this.getFiles(post, [file]).then(responseFiles => {
                if (typeof responseFiles === "boolean") return true;

                return this.fileService.downloadFile(responseFiles[0].id).then(download => {
                    file.blob = download;
                    file.href = window.URL.createObjectURL(download);
                    file.downloading = false;
                    return true;
                });
            });
        },

        async downloadFiles(post: object, files: null) {
            files = (files) ? files : this.files;

            return await this.getFiles(post, files).then(responseFiles => {
                if (typeof responseFiles === "boolean") return true;

                const promises = [];

                responseFiles.forEach(responseFile => {
                    promises.push(this.fileService.downloadFile(responseFile.id, responseFile));
                });

                if (!promises.length) return true;

                return Promise.all(promises).then(downloads => {
                    files.forEach(file => {
                        file.downloading = false;
                    });

                    downloads.forEach((download, i) => {
                        responseFiles[i].blob = download;
                        responseFiles[i].href = window.URL.createObjectURL(download);
                    });
                    return true;
                });
            });
        },

        async removeFile(file = null) {
            file = (file) ? file : this.file;

            if (file.id) {
                file.disabled = true;
                return await this.fileService.deleteFile(file.id).then(res => {
                    file.href = null;
                    file.name = null;
                    file.error = null;
                    file.id = null;
                    file.disabled = false;
                    return true;
                });
            }
        },

        async storeFile(post, download = false) {
            if (!post.file)
                return true;

            const data = { ...post };

            data.file = post.file[0];

            return await this.$store.dispatch('project/uploadFile', data).then(response => {
                if (response instanceof Error) {
                    this.errorData = this.getErrorMessage(response);
                    return false;
                }

                if (download) {
                    return this.downloadFile(post);
                } else {
                    return true;
                }
            });
        },

        async storeFiles(post, download = false) {
            if (!post.files)
                return true;

            const promises = [];

            for (let i = 0; i < post.files.length; i++) {
                if (!post.files[i].file) continue;
                const filePost = { ...post.files[i] };
                filePost.id = post.id;
                filePost.owner = post.owner;
                filePost.type = post.type;
                promises.push(this.storeFile(filePost, download));
            }

            if (promises.length) {
                return await Promise.all(promises).then(response => {
                    return !response.includes(false);
                });
            } else {
                return true;
            }
        },

        prepareStoringFiles(post = null, files = null) {
            const maxFiles = (this.maxFiles) ? this.maxFiles : 5;
            post = (post) ? post : this.post;
            files = (files) ? files : this.files;

            for (let i = 0; i < maxFiles; i++) {
                const file = {
                    disabled: true,
                    name: null,
                    href: null,
                    downloading: false,
                };

                post.files.push(file);
                files.push({ ...file });
            }

            this.downloadFiles(post, files);
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class StoreFile extends Vue {

}